export default __webpack_public_path__ + "static/media/close.54774f65.svg";